export default __webpack_public_path__ + "static/media/contact-us.09804da1.svg";